import { Fragment } from 'react';

import { DateValueFormatter, dateFNS } from '@gogame/intl-ts';

const ChartDateFormatter = ({
  template,
  base,
  compared,
  compareMode,
  placeholder = '—',
}) => {
  const compareDateVisible = compareMode && !dateFNS.isSameDay(base, compared);

  return (
    <Fragment>
      {base ? (
        <DateValueFormatter
          value={base}
          template={template}
          timeZone={'local'}
        />
      ) : (
        placeholder
      )}

      {compareDateVisible ? (
        <Fragment>
          &nbsp;/&nbsp;
          {compared ? (
            <DateValueFormatter
              value={compared}
              template={template}
              timeZone={'local'}
            />
          ) : (
            placeholder
          )}
        </Fragment>
      ) : null}
    </Fragment>
  );
};

export default ChartDateFormatter;
